import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { RootState } from '~/store/reducers';

export const selectIsManagerInChannel = (channelId) => (state) =>
  state?.profileSidebar?.profiles.some(
    (profile) => profile.id === channelId && profile.isManager
  );

export const selectCurrentProfileId = (state) =>
  state?.profileSidebar?.selectedProfileId;

export const selectCurrentProfile = (state) => {
  const profileId = selectCurrentProfileId(state);

  return state.profileSidebar?.profiles?.find((p) => p.id === profileId);
};

export const selectProfileTime = (state) =>
  state?.profileSidebar?.selectedProfileId;

export const selectProfiles = (state): [] => {
  return state?.profileSidebar?.profiles || [];
};

export const selectHasProfiles = (state): boolean => {
  return selectProfiles(state).length !== 0;
};

export const selectNotificationsEnabled = createDraftSafeSelector(
  (state: RootState) => selectProfiles(state),
  (_, profileId?: string) => profileId,
  (profiles, profileId) => {
    const profile = profiles.find((prof) => prof.id === profileId);
    return !profile?.isDisconnected && profile?.hasPushNotitications;
  }
);

export const selectProfileTimezone = createSelector(
  (state: RootState) => selectProfiles(state),
  (_, profileId?: string) => profileId,
  (profiles, profileId) => {
    const profile = profiles.find((prof) => prof.id === profileId);
    return profile?.timezone;
  }
);
